import ServiceBase from './ServiceBase'
import { getCaptchaToken } from '@/utils/ReCaptchaUtils'
import { localDriver } from '@/utils/localDriver'

class UserService extends ServiceBase {
  async authenticated(): Promise<boolean> {
    const customerId = sessionStorage.getItem('customer_id')
    if (!customerId) {
      return false
    } else {
      return true
    }
  }

  async login(loginData) {
    return new Promise<any>((resolve, reject) => {
      this.webPost(
        loginData,
        (res) => {
          resolve(res)
        },
        'account/login',
        (error) => {
          reject(error)
        }
      )
    })
  }

  checkState() {
    const queryParams = new URLSearchParams(window.location.search)
    const params = {}
    const token = queryParams.get('token')
    if (token != null) {
      params['token'] = token
    }
    const ad = queryParams.get('ad')

    const apiUrl =
      'account/login/checkState' + (token ? '&token=' + token : '') + (ad ? '&ad=' + ad : '')

    return new Promise<any>((resolve, reject) => {
      this.webPost(
        {},
        (res) => {
          resolve(res)
        },
        apiUrl,
        (error) => {
          reject(error)
        },
        3000,
        3
      )
    })
  }

  async register(registerInfo: any): Promise<any> {
    const apiUrl = `account/register`
    return new Promise<any>((resolve, reject) => {
      this.webPost(
        registerInfo,
        async (result) => {
          let hasError = false
          for (const field in result) {
            if (field.startsWith('error_') && result[field] != '') {
              hasError = true
              break
            }
          }
          if (!hasError) {
            await localDriver.setItem('customer_id', result.customer_id || 0)
            await localDriver.setItem('customerInfo', result)
          }
          resolve(result)
        },
        apiUrl,
        (error) => {
          reject(error)
        }
      )
    })
  }

  async saveAgentInfo(agentInfo: any) {
    const apiUrl = 'account/register/add_customer_company_info'
    return new Promise<any>((resolve, reject) => {
      this.webPost(
        agentInfo,
        async (result) => {
          let hasError = false
          for (const field in result) {
            if (field.startsWith('error_') && result[field] != '') {
              hasError = true
              break
            }
          }
          if (!hasError) {
            const info = await localDriver.getItem('customerInfo')
            info.company_id = result.company_id
            await localDriver.setItem('customerInfo', info)
          }
          resolve(result)
        },
        apiUrl,
        (error) => {
          reject(error)
        }
      )
    })
  }

  async searchAgentCompanies(name: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.webPost(
        { name },
        (result) => resolve(result),
        'account/register/search_customer_companies',
        (error) => reject(error)
      )
    })
  }

  async sendVerifyCode(firstname: string, phoneNumber: string): Promise<any> {
    const apiUrl = `account/register/smsCode`
    const captchaToken = await getCaptchaToken('smsCode')
    return new Promise<any>((resolve, reject) => {
      this.webPost(
        {
          firstname: firstname,
          phone: phoneNumber,
          captchaToken: captchaToken
        },
        (result) => {
          resolve(result)
        },
        apiUrl,
        (error) => {
          reject(error)
        }
      )
    })
  }

  async logout() {
    const apiUrl = 'account/logout'
    return new Promise((resolve, reject) => {
      this.webPost(
        {},
        () => {
          resolve(true)
        },
        apiUrl,
        (error) => {
          reject(error)
        }
      )
    })
  }
}

export default new UserService()
